import React, { useMemo, type FC } from 'react'
import { useIntl } from 'react-intl'
import { useAtom } from 'jotai'
import { FormElement, Select } from 'mailup-web-components'
import { filterFormImmerAtom } from '../../state/state'
import { type ConditionProps } from '../../types'
import { formatOpts } from '../../utils/conditionOptions'
import { type UiFormat, type UiProfileSpec } from '../../filterConditionTypes'
import { getDefaultValueByFormat } from '../../utils/conditionUtils'
import { DateTimeMatch } from 'Types/FilterCondition'

const FormatType: FC<ConditionProps> = ({ blockIndex, condIndex }) => {
  const intl = useIntl()
  const [filter, setFilter] = useAtom(filterFormImmerAtom)
  const cond = filter.Blocks[blockIndex].Conditions[condIndex]
  const spec = cond.Spec as Partial<UiProfileSpec>

  const formatOptions = useMemo(() => formatOpts(intl), [intl])

  const handleChange = (value: UiFormat): void => {
    
    const defaultValue = getDefaultValueByFormat(value)
    setFilter((draft) => {
      const cond = draft.Blocks[blockIndex].Conditions[condIndex]
      ;(cond.Spec as any) = {
        Identifier: (cond.Spec as Partial<UiProfileSpec>).Identifier,
        Value: defaultValue,
        Format: value,
        Match: value === "DateFormat9" ? DateTimeMatch.PlusXHoursEqualsToNow : undefined
      }
    })
  }

  return (
    <FormElement>
      <Select
        placeholder={intl.formatMessage({
          id: 'Load.Filters.FormatTypePlaceholder',
        })}
        options={formatOptions}
        value={spec.Format}
        onChange={handleChange}
        data-mu-test='input-select-format'
      />
    </FormElement>
  )
}

export default FormatType
